import { Button } from "./buttons";


/** @param {{ controller: SamedayStatusController }} param0 */
export function Pagination({ offset, pageSize, total, maxVisibleButtons = 5, onChangePage }) {
    const ellipsis = () => <div className="ellipsis" key={Math.random()}>...</div>;

    const currentPage = Math.floor(offset/pageSize) + 1;
    const maxPages = Math.ceil(total/pageSize);
    const range = `${(currentPage-1)*pageSize + 1} - ${Math.min(currentPage*pageSize, total)}`;

    const startPageButton = maxPages <= maxVisibleButtons || currentPage < maxVisibleButtons - 2 ? 1 : 
        currentPage + 2 < maxPages ? currentPage - maxVisibleButtons + 3 : 
        maxPages - maxVisibleButtons + 1 ; 

    const endPageButton = Math.min(startPageButton + maxVisibleButtons - 1, maxPages);

    const buttons = [];

    for(let p = startPageButton; p <= endPageButton; p++) {
        const active = p === currentPage;
        const pageButton = <Button key={p} onClick={() => onChangePage(p)} color={active ? "blue" : undefined}>{p}</Button>
        buttons.push(pageButton);
    }


    if(startPageButton > 1) buttons[0] = ellipsis();
    if(endPageButton < maxPages) buttons[buttons.length - 1] = ellipsis();


    const isFirstPage = currentPage <= 1;
    const isLastPage = currentPage >= maxPages;

    const prevButton = <Button key="prev" disabled={isFirstPage} onClick={() => onChangePage(currentPage - 1)}>{"<<"}</Button>
    const nextButton = <Button key="prev" disabled={isLastPage} onClick={() => onChangePage(currentPage + 1)}>{">>"}</Button>

    return <div className="pagination">
        <div className="details">Showing entries <b>{range}</b> of <b>{total}</b></div>
        <div className="buttons">{maxPages > 1 ? [ prevButton, ...buttons, nextButton ] : ""}</div>
    </div>;
}